<template>
  <v-avatar tile :size="avatarSize">
    <v-img :src="userAvatarUrl">
      <template v-slot:placeholder>
        <v-progress-circular :size="avatarSize" indeterminate></v-progress-circular>
      </template>
      <template v-slot:error>
        <div class="error-avatar">
          <v-icon :size="avatarSize" color="white">mdi-account-outline</v-icon>
        </div>
      </template>
    </v-img>
  </v-avatar>
</template>

<script setup>
// import { defineProps } from 'vue'

defineProps({
  avatarSize: {
    type: Number,
    default: 24,
  },
  userAvatarUrl: {
    type: String,
    default: '',
  },
})

</script>

<style scoped>
.error-avatar {
  background-color: gray;
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--avatar-size);
  height: var(--avatar-size);
}
</style>
